export default function convertToNumber(str: string): string {
  const newStr = str.replace(/[^\d]+/g, '');
  return newStr;
}
